import { useState } from "react";
import { useTranslation } from "react-i18next";
import { AnimatePresence, motion } from "framer-motion";
import { Plus, Minus } from "lucide-react";
import { SectionHeading } from "./SectionHeading";

type Entry = { q: string; a: string };

export function FAQ() {
  const { t } = useTranslation();
  const items = t("landing.faq.items", { returnObjects: true }) as Entry[];
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section id="faq" className="relative scroll-mt-16 border-t border-slate-200/80 bg-white py-20 dark:border-white/5 dark:bg-slate-950 sm:py-28">
      <div className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-8">
        <SectionHeading tag={t("landing.faq.tag")} title={t("landing.faq.title")} />

        <ul className="space-y-2.5">
          {items.map((it, i) => {
            const isOpen = open === i;
            return (
              <li
                key={i}
                className="overflow-hidden rounded-2xl bg-white ring-1 ring-slate-200 shadow-sm dark:bg-white/[0.02] dark:ring-white/10 dark:shadow-none"
              >
                <button
                  type="button"
                  onClick={() => setOpen(isOpen ? null : i)}
                  className="w-full flex items-start justify-between gap-3 px-5 py-4 text-left"
                  aria-expanded={isOpen}
                >
                  <span className="text-sm font-semibold text-slate-900 dark:text-white sm:text-base">{it.q}</span>
                  <span className="flex-none mt-0.5 text-slate-400">
                    {isOpen ? <Minus size={16} /> : <Plus size={16} />}
                  </span>
                </button>
                <AnimatePresence initial={false}>
                  {isOpen && (
                    <motion.div
                      key="body"
                      initial={{ height: 0, opacity: 0 }}
                      animate={{ height: "auto", opacity: 1 }}
                      exit={{ height: 0, opacity: 0 }}
                      transition={{ duration: 0.25 }}
                      className="overflow-hidden"
                    >
                      <p className="px-5 pb-5 text-sm leading-relaxed text-slate-600 dark:text-slate-300">{it.a}</p>
                    </motion.div>
                  )}
                </AnimatePresence>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}
